import { render, staticRenderFns } from "./View_inspiration.vue?vue&type=template&id=5649ab2c&scoped=true&"
import script from "./View_inspiration.vue?vue&type=script&lang=js&"
export * from "./View_inspiration.vue?vue&type=script&lang=js&"
import style0 from "./View_inspiration.vue?vue&type=style&index=0&id=5649ab2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649ab2c",
  null
  
)

export default component.exports